import { render, staticRenderFns } from "./TestApplicationCandidatesByDate.vue?vue&type=template&id=04fa784c"
import script from "./TestApplicationCandidatesByDate.vue?vue&type=script&lang=js"
export * from "./TestApplicationCandidatesByDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports